import React from "react";

function ModalOtherTechnologies({ otherSkills }) {
  return otherSkills.map((skill) => <li key={skill}>{skill}</li>);
}

export default ModalOtherTechnologies;
